import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconFaceFurious = ({ size = 18, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M6.5 7.5l4 2M17.5 7.5l-4 2' />
      <path d='M9 11.5h.01M15 11.5h.01' strokeWidth='2.8' />
      <path d='M8 17.5a4.5 3.5 0 0 1 8 0' />
    </g>
  </SDIcon>
)

export default IconFaceFurious
